import { Component, Prop } from 'vue-property-decorator';
import Vue from '@/VueBase';
import { mapState } from 'vuex';
import _ from 'lodash';

@Component({
  computed: {
    ...mapState([]),
  },
})
export default class NavigationMixins extends Vue {
  @Prop({ default: true })
  public readonly canGoBack!: boolean;
  @Prop()
  public readonly prevName!: string;
  @Prop()
  public readonly prevButton!: string;
  @Prop({ default: true })
  public readonly prevButtonEnabled!: boolean;
  @Prop()
  public readonly nextName!: string;
  @Prop()
  public readonly nextButton!: string;
  @Prop({ default: true })
  public readonly nextButtonEnabled!: boolean;
  @Prop({ default: false })
  public readonly nextFlash!: boolean;
  
  get nextNameTrimmed() {
    if(this.nextName && this.nextName.length>60) return this.nextName.substring(0, 60).trim()+'...';
    return this.nextName;
  }

  get prevNameTrimmed() {
    if(this.prevName && this.prevName.length>60) return this.prevName.substring(0, 60).trim()+'...';
    return this.prevName;
  }

  onCandidateClick(candidate: CandidateSimpleModel) {
    this.$emit('remove', candidate.Id);
  }

  onCancelVoteClick() {
    this.$emit('cancel');
  }

  onPrev() {
    if (!this.prevButtonEnabled) return;
    this.$emit('prev');
  }
  onNext() {
    if (!this.nextButtonEnabled) return;
    this.$emit('next');
  }

  created() {
    window.addEventListener('resize', this.onResize);
  }
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  }

  mounted() {
    this.onResize();
  }

  public onResize = _.debounce(() => {
    let space = this.$refs.navspace as HTMLElement;
    let nav = this.$refs.nav as HTMLElement;
    if (space && nav) {
      space.style.height = nav.offsetHeight + 'px';
    }
  }, 500);
}
